import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  INCOMPLETE_ORDERS_FAILURE,
  UPDATE_ORDER_STATUS_REQUESTED,
} from '../types';

const INITIAL_STATE = {
  orders: [],
  ordersPagination: {},
  isFetching: false,
  status: 'waiting',
  errors: null
};

const incompleteOrders = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case INCOMPLETE_ORDERS_REQUESTED:
      return Object.assign({}, state, {
        orders: [],
        ordersPagination: {},
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case INCOMPLETE_ORDERS_SUCCESS:
      return Object.assign({}, state, {
        orders: action.payload.orders || [],
        ordersPagination: action.payload.order_pagination,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case INCOMPLETE_ORDERS_FAILURE:
      return Object.assign({}, state, {
        orders: [],
        ordersPagination: {},
        isFetching: false,
        status: 'error',
        errors: action.error
      });

    case UPDATE_ORDER_STATUS_REQUESTED:
      newState.orders = newState.orders.filter(order => order.id !== action.orderId);
      return newState;

    default:
      return state;
  }
}

export default incompleteOrders;
